exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.linkbar-wrapper[data-v-6fec1086] {\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: 100;\n}\n.el-menu-item.is-active[data-v-6fec1086] {\n    color: #bfcbd9;\n   float: left;\n   /* margin-left: 15px; */\n    /* text-align: center; */\n    /*border-bottom: 5px solid #20a0ff;*/\n}\n  /* .el-menu-item:hover {\n    color: #20a0ff;\n  } */\n.el-menu-item > a[data-v-6fec1086] {\n    text-decoration: none;\n   margin-left: -15px;\n   font-size: 24px;\n   /* font-family: '华文行楷'; */\n}\n.el-menu >img[data-v-6fec1086] {\n   /* margin: 18px auto; */\n   /* width: 50px; */\n   height: 36px;\n    float: left;\n    margin: 10px 10px;\n   margin-left: 20px;\n}\n.admin-title[data-v-6fec1086]{\n    line-height: 60px;\n    font-size: 18px;\n    color: #ffffff;\n    margin-left: 30px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fec1086","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/Linkbar.vue
// module id = 257
// module chunks = 99